import {
    AirOutlined,
    DeviceThermostatOutlined,
    FavoriteBorderOutlined,
    FavoriteOutlined,
    MonitorWeightOutlined,
    WaterDropOutlined
} from '@mui/icons-material';

export const patientMeasurementTypes = [
    {
        type: 'M_HEARTRATE',
        labelKey: 'userPage.metrics.heartRate',
        icon: FavoriteBorderOutlined,
        fields: [{ field: 'hr', labelKey: 'userPage.metrics.heartRate', unit: 'bpm' }]
    },
    {
        type: 'M_BLOOD_PRESSURE',
        labelKey: 'userPage.metrics.bloodPressure',
        icon: FavoriteOutlined,
        fields: [
            {
                field: 'systolic',
                labelKey: 'userPage.measurements.columns.systolic',
                unit: 'mmHg'
            },
            {
                field: 'diastolic',
                labelKey: 'userPage.measurements.columns.diastolic',
                unit: 'mmHg'
            },
            {
                field: 'hr',
                labelKey: 'userPage.measurements.columns.heartRate',
                unit: 'bpm'
            }
        ]
    },
    {
        type: 'M_BLOOD_OXYGEN',
        labelKey: 'userPage.metrics.bloodOxygen',
        icon: AirOutlined,
        fields: [
            { field: 'spo2', labelKey: 'userPage.metrics.bloodOxygen', unit: '%' },
            {
                field: 'hr',
                labelKey: 'userPage.measurements.columns.heartRate',
                unit: 'bpm'
            }
        ]
    },
    {
        type: 'M_BLOOD_SUGAR',
        labelKey: 'userPage.metrics.bloodSugar',
        icon: WaterDropOutlined,
        fields: [
            { field: 'glicose', labelKey: 'userPage.metrics.bloodSugar', unit: 'mg/dL' }
        ]
    },
    {
        type: 'M_BODY_TEMPERATURE',
        labelKey: 'userPage.metrics.temperature',
        icon: DeviceThermostatOutlined,
        fields: [
            {
                field: 'temperature',
                labelKey: 'userPage.metrics.temperature',
                unit: '\u00b0C'
            }
        ]
    },
    {
        type: 'M_WEIGHT',
        labelKey: 'userPage.metrics.weight',
        icon: MonitorWeightOutlined,
        fields: [{ field: 'weight', labelKey: 'userPage.metrics.weight', unit: 'kg' }]
    }
];
